import { getEmpresasRepository } from '../repositories';
import { CreateEmpresaDto, EmpresaResponse, ApiError } from './types';

export class EmpresaService {
  private static get repository() {
    return getEmpresasRepository();
  }

  /**
   * Cria uma nova empresa na landing page
   * @param empresaData - Dados da empresa
   * @returns Promise com resposta da empresa criada e token de acesso
   */
  static async createEmpresa(empresaData: CreateEmpresaDto): Promise<EmpresaResponse> {
    try {
      const response = await this.repository.create(empresaData);

      // Token is handled via cookie
      return response;
    } catch (error: any) {
      // Re-throw o erro original para manter todas as informações (response, code, etc)
      // O handleApiError transforma em ApiError, mas perdemos informações importantes
      // Melhor lançar o erro original e deixar o componente tratar
      throw error;
    }
  }



  /**
   * Trata erros da API
   */
  private static handleApiError(error: any): ApiError {
    if (error.response?.data) {
      return {
        message: error.response.data.message || error.message || 'Erro na requisição',
        statusCode: error.response.status || error.statusCode || 500,
        error: error.response.data.error || error.error || 'Unknown Error',
      };
    }

    if (error.message) {
      return {
        message: error.message,
        statusCode: 500,
        error: 'Network Error',
      };
    }

    return {
      message: 'Erro de conexão com o servidor',
      statusCode: 500,
      error: 'Network Error',
    };
  }
}
